import { Trans } from "react-i18next";
import styles from "../css/heatmaps/BoxesFroSmall.module.css";

const BoxesFroSmall = ({ children, content, bgColor = "white", icons, objectContent = false }) => {
  const showIcons = icons && icons.length > 0;

  return (
    <section className="section">
      <article className="container">
        {children && (
          <div
            className={`box is-connected center ${
              bgColor === "green" && "box--back"
            }`}
          >
            {children}
          </div>
        )}
        {content.texts.map((item, index) => (
          <div
            key={index}
            className={`box is-connected center ${
              bgColor === "green" && "box--back"
            } ${styles.box}`}
          >
            {showIcons && <img src={icons[index % icons.length]} style={{alignSelf: "flex-start"}} alt="icon" />}
            
            {objectContent ? (
              // Pokud je objectContent true, zpracuje objekt s titulkem a textem
              <div className={styles.contentWrapper}>
                <h3 style={{marginBottom: "8px"}} className={styles.title}>{item.title}</h3>
                <p className={styles.text}>{item.text}</p>
              </div>
            ) : (
              // Původní chování pro pole stringů (i18n klíče)
              <p className={styles.text}>
                <Trans i18nKey={item} components={[<strong />]} />
              </p>
            )}
          </div>
        ))}
      </article>
    </section>
  );
};

export default BoxesFroSmall;